import { all, takeLatest } from 'redux-saga/effects';

import { getBigScreenSaga } from './getBigScreenSaga';
import * as actionTypes from '../actionTypes';

export default function* watchBigScreen() {
    yield all([takeLatest(actionTypes.GET_BIG_SCREEN_DEEP_LINK_REQUEST, getBigScreenSaga)]);
}
